import {BaseQueryApi, FetchArgs, createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {environment} from '../../util/Environment'
import jwt_decode from 'jwt-decode'
import { signOut } from '../auth/Auth.slice'

const baseQuery = fetchBaseQuery({
  baseUrl: environment.apiUrl.root,
  prepareHeaders: (headers, api) => {
    const state: any = api.getState()
    const idToken = state.authReducer.store?.tokens?.idToken
    if (idToken && !headers.has('NO_AUTH')) {
      headers.set('Authorization', `Bearer ${idToken}`)
    }
    return headers
  },
  //   credentials: 'include',
  //   prepareHeaders: (headers, { getState }) => {
  //     const token = getState()?.auth?.token;
  //     const tokenExpired = TokenService.isAccessExpired();
  //     if (token) {
  //       if (!tokenExpired) {
  //         headers.set('authorization', `Bearer ${token.accessToken}`);
  //       } else {
  //         headers.set('authorization', `Bearer ${token.accessToken}`);
  //         headers.set('x-refresh', `${token.refreshToken}`);
  //       }
  //     }
  //     return headers;
  //   },
})

const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
) => {
  let result = await baseQuery(args, api, extraOptions)
  if (result?.error) {
    // const state: any = api.getState()
    // const refreshToken = state.authReducer.store?.tokens?.refreshToken
    // if (refreshToken) {      
    //   const refreshResult = await baseQuery(
    //     {
    //       url: `${environment.apiUrl.security}/refresh`,
    //       method: 'POST',
    //       body: JSON.stringify({refreshToken: refreshToken}),
    //     },
    //     {...api},
    //     extraOptions
    //   )
    //   console.log(refreshResult)
    // } else {
    //   api.dispatch(signOut())
    // }
  }

  //-------------------------------------------------------------------------------
  //   if (result?.error?.originalStatus === 403) {
  //     console.log('sending refresh token');
  //     // send refresh token to get new access token
  //     const refreshResult = await baseQuery('/refresh', api, extraOptions);
  //     console.log(refreshResult);
  //     if (refreshResult?.data) {
  //       const user = api.getState().auth.user;
  //       // store the new token
  //       api.dispatch(setCredentials({ response: refreshResult.data }));
  //       // retry the original query with new access token
  //       result = await baseQuery(args, api, extraOptions);
  //     } else {
  //       api.dispatch(logOut());
  //     }
  //   }
  return result
}

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
})
